import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import App from './App';
import { appTheme } from './theme/theme';
import { AuthProvider } from './app/AuthContext';
import { ErrorBoundary } from './app/ErrorBoundary';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import './i18n'; // Initialize i18n
import './index.css';

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <FeatureFlagsProvider>
            <AuthProvider>
              <ConfigProvider theme={appTheme}>
                <AntApp>
                  <App />
                </AntApp>
              </ConfigProvider>
            </AuthProvider>
          </FeatureFlagsProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  );
}
